// Übersetzungen für das Recall-System (Wiedereinbestellung PZR/Kontrolle).

export const recalls = {
  de: {
    recalls: {
      title: 'Recalls',
      subtitle: 'Automatische Wiedereinbestellung — z. B. zur Zahnreinigung oder Kontrolle.',
      tabDue: 'Fällig',
      tabSettings: 'Einstellungen',
      tabStats: 'Statistik',
      loading: 'Lade Recalls…',

      // Fällig-Tab
      dueEmpty: 'Keine fälligen Recalls. 🎉',
      colPatient: 'Patient',
      colType: 'Typ',
      colDue: 'Fällig am',
      colAttempts: 'Versuche',
      colConsent: 'E-Mail-Opt-in',
      colActions: 'Aktionen',
      overdue: 'überfällig',
      consentGranted: 'erteilt',
      consentDenied: 'abgelehnt',
      consentRevoked: 'widerrufen',
      consentNeverAsked: 'nie gefragt',
      consentGrantedAt: 'Opt-in erteilt am {{date}} ({{version}})',
      consentNoRevocation: 'kein Widerruf vorliegend',
      consentRevokedAt: 'Widerrufen am {{date}}',
      callTask: '📞 Anrufen',
      callTaskHint: 'Kein E-Mail-Opt-in — bitte telefonisch wiedereinbestellen.',
      noEmail: 'keine E-Mail',
      sendNow: 'Jetzt senden',
      sending: 'Sendet…',
      dismiss: 'Verwerfen',
      sentToast: 'Recall-Mail versendet.',
      sentBookedToast: 'Patient hat bereits einen Folgetermin — Recall geschlossen.',
      sendBlockedToast: 'Versand nicht möglich: {{reason}}',
      dismissedToast: 'Recall verworfen.',
      reasonNoConsent: 'kein E-Mail-Marketing-Opt-in',
      reasonNoEmail: 'keine E-Mail-Adresse hinterlegt',
      reasonOther: 'siehe Log',
      lastNotified: 'Zuletzt erinnert: {{date}}',
      runNow: 'Fällige jetzt verarbeiten',
      running: 'Läuft…',
      runResult: 'Lauf abgeschlossen: {{sent}} gesendet, {{skipped}} übersprungen, {{booked}} bereits gebucht.',

      // Einstellungen-Tab
      settingsTitle: 'Recall-Einstellungen',
      enabled: 'Recall-System aktiv (täglicher Versand um 08:00 Uhr)',
      retryAfterWeeks: 'Erneut erinnern nach (Wochen)',
      maxAttempts: 'Max. Versuche pro Recall',
      typesTitle: 'Recall-Typen',
      typeEnabled: 'Aktiv',
      typeLabel: 'Bezeichnung',
      typeInterval: 'Intervall (Monate)',
      typeProcedures: 'Behandlungen, die diesen Recall auslösen',
      typeProceduresHint: 'Nach Abschluss einer dieser Behandlungen wird der Recall geplant. Ohne Zuordnung ist der Typ wirkungslos.',
      noProceduresWarning: '⚠️ Keine Behandlungen zugeordnet — dieser Typ löst keine Recalls aus.',
      defaultMappingHint: 'ℹ️ Standard-Zuordnung aktiv (automatisch erkannt). Beim Speichern wird die aktuelle Auswahl übernommen.',
      saved: 'Recall-Einstellungen gespeichert.',
      consentNote: 'Recall-Mails gehen nur an Patienten mit E-Mail-Marketing-Einwilligung aus dem Anamnesebogen. Ohne Einwilligung erscheinen fällige Recalls hier als Anruf-Aufgabe. Jede Mail enthält einen Abmelde-Link.',

      // Statistik-Tab
      statsTitle: 'Recall-Erfolg',
      statsPeriod: 'Zeitraum',
      days30: '30 Tage',
      days90: '90 Tage',
      days365: '1 Jahr',
      statSent: 'Mails versendet',
      statBooked: 'Termine gebucht',
      statConversion: 'Buchungsquote',
      statOpen: 'Offene Recalls',
      statNoConsent: 'Fällig ohne Opt-in (Anrufliste)',

      errorLoad: 'Recalls konnten nicht geladen werden.',
      errorSave: 'Speichern fehlgeschlagen.',
    },
  },
  es: {
    recalls: {
      title: 'Recalls',
      subtitle: 'Reincorporación automática de pacientes — p. ej., para limpieza o revisión.',
      tabDue: 'Pendientes',
      tabSettings: 'Ajustes',
      tabStats: 'Estadísticas',
      loading: 'Cargando recalls…',

      dueEmpty: 'No hay recalls pendientes. 🎉',
      colPatient: 'Paciente',
      colType: 'Tipo',
      colDue: 'Vence el',
      colAttempts: 'Intentos',
      colConsent: 'Opt-in de correo',
      colActions: 'Acciones',
      overdue: 'vencido',
      consentGranted: 'concedido',
      consentDenied: 'rechazado',
      consentRevoked: 'revocado',
      consentNeverAsked: 'nunca preguntado',
      consentGrantedAt: 'Opt-in concedido el {{date}} ({{version}})',
      consentNoRevocation: 'sin revocación registrada',
      consentRevokedAt: 'Revocado el {{date}}',
      callTask: '📞 Llamar',
      callTaskHint: 'Sin opt-in de correo — por favor, reincorporar por teléfono.',
      noEmail: 'sin correo',
      sendNow: 'Enviar ahora',
      sending: 'Enviando…',
      dismiss: 'Descartar',
      sentToast: 'Correo de recall enviado.',
      sentBookedToast: 'El paciente ya tiene una cita de seguimiento — recall cerrado.',
      sendBlockedToast: 'Envío no posible: {{reason}}',
      dismissedToast: 'Recall descartado.',
      reasonNoConsent: 'sin opt-in de marketing por correo',
      reasonNoEmail: 'sin dirección de correo registrada',
      reasonOther: 'ver registro',
      lastNotified: 'Último recordatorio: {{date}}',
      runNow: 'Procesar pendientes ahora',
      running: 'Procesando…',
      runResult: 'Proceso completado: {{sent}} enviados, {{skipped}} omitidos, {{booked}} ya reservados.',

      settingsTitle: 'Ajustes de recall',
      enabled: 'Sistema de recall activo (envío diario a las 08:00)',
      retryAfterWeeks: 'Recordar de nuevo tras (semanas)',
      maxAttempts: 'Intentos máx. por recall',
      typesTitle: 'Tipos de recall',
      typeEnabled: 'Activo',
      typeLabel: 'Denominación',
      typeInterval: 'Intervalo (meses)',
      typeProcedures: 'Tratamientos que activan este recall',
      typeProceduresHint: 'Al completar uno de estos tratamientos se programa el recall. Sin asignación, el tipo no tiene efecto.',
      noProceduresWarning: '⚠️ Sin tratamientos asignados — este tipo no genera recalls.',
      defaultMappingHint: 'ℹ️ Asignación estándar activa (detectada automáticamente). Al guardar se conserva la selección actual.',
      saved: 'Ajustes de recall guardados.',
      consentNote: 'Los correos de recall solo se envían a pacientes con consentimiento de marketing por correo del cuestionario de anamnesis. Sin consentimiento, los recalls pendientes aparecen aquí como tarea de llamada. Cada correo incluye un enlace de baja.',

      statsTitle: 'Éxito de los recalls',
      statsPeriod: 'Período',
      days30: '30 días',
      days90: '90 días',
      days365: '1 año',
      statSent: 'Correos enviados',
      statBooked: 'Citas reservadas',
      statConversion: 'Tasa de reserva',
      statOpen: 'Recalls abiertos',
      statNoConsent: 'Pendientes sin opt-in (lista de llamadas)',

      errorLoad: 'No se pudieron cargar los recalls.',
      errorSave: 'Error al guardar.',
    },
  },
};
